export default __webpack_public_path__ + "static/media/photo--sm--75.b0e95111.jpg";